module.exports = __webpack_public_path__ + "static/media/Generic.e5641503.jpg";